const hide = () => {
  document.getElementById('sticky_banner').style.display = 'none';
  // TODO: Ajouter localStorage day + 7 jours
  if (window.localStorage.getItem('stickyBanner') === null) {
    const now = new Date();

    var localStorageData = JSON.stringify({
      keywordName: 'stickyBanner',
      expires: now.getTime() + 1000 * 60 * 60 * 24 * 7,
      //expires: now.getTime() + 1000 * 10,
    });

    window.localStorage.setItem('stickyBanner', localStorageData);
  } else {
    return;
  }
};

document.addEventListener('DOMContentLoaded', () => {
  if (window.localStorage.getItem('stickyBanner') !== null) {
    document.getElementById('sticky_banner').style.display = 'none';
    const now = new Date();
    const stickyStorage = JSON.parse(
      window.localStorage.getItem('stickyBanner')
    );

    if (now.getTime() > stickyStorage.expires) {
      window.localStorage.removeItem('stickyBanner');
      document.getElementById('sticky_banner').style.display = 'block';
    }
  }
});

function onCrossClick() {
  hide();
}

const cross = document.getElementById('sticky__cross_image');

cross.addEventListener('click', onCrossClick);

const cross2 = document.getElementById('link_to_typeform_inscription');

cross2.addEventListener('click', onCrossClick);
